<template>
	<div class="share-image-dialog">
		<div class="heading">微信分享图</div>

		<div class="img-button" ref="buttonWrapper">
			<div class="button-item" v-for="item in list" :key="item.id"
				:class="{ active: item.id === selectedCategoryId }" @click="buttonOnclick(item)" ref="buttonItems">
				{{ item.categoryName }}
			</div>
			<div class="indicator" :style="indicatorStyle"></div>
		</div>

		<div class="img-list">
			<div class="img-item" v-for="item in imagelist" :key="item.id" :class="{ active: item.id === selectedId }"
				@click="selectImg(item)">
				<img :src="item.imageUrl" :alt="item.imageName" />
				<img v-if="item.id === selectedId" class="icon" src="https://ossfastmake.mustke.com/qrCode/tupian/1747032457200.svg" />
			</div>
			<div v-if="imagelist.length === 0" class="empty">当前分类无内容</div>
		</div>

		<div class="operation">
			<div class="cancel" @click="$emit('cancel')">取消</div>
			<div class="confirm" @click="confirm">保存</div>
		</div>
	</div>
</template>

<script>
	import {
		getShareTypeList,
		getShareImageList
	} from "@/api/index.js";

	export default {
		name: "ShareImageDialog",
		props: {
			visible: Boolean,
			dataObj: Object,
		},
		data() {
			return {
				list: [],
				imagelist: [],
				selectedId: "",
				selectedUrl: "",
				selectedCategoryId: null,
				indicatorLeft: 0,
				indicatorWidth: 0,
			};
		},
		async mounted() {
			await this.getList();
			if (this.list.length > 0) {
				this.buttonOnclick(this.list[0]);
			}
			this.$nextTick(() => {
				this.updateIndicator();
			});
		},
		methods: {
			async getList() {
				const res = await getShareTypeList();
				this.list = res.data || [];
			},
			async buttonOnclick(item) {
				this.selectedCategoryId = item.id;
				const res = await getShareImageList({
					categoryId: item.id
				});
				this.imagelist = [...(res.data || [])];

				if (this.dataObj && this.dataObj.shareImgId) {
					const selected = this.imagelist.find(
						(i) => i.id == this.dataObj.shareImgId
					);
					if (selected) {
						this.selectedId = selected.id;
						this.selectedUrl = selected.imageUrl;
					} else {
						this.selectedId = "";
						this.selectedUrl = "";
					}
				} else {
					this.selectedId = "";
					this.selectedUrl = "";
				}

				this.$nextTick(() => {
					this.updateIndicator();
				});
			},
			selectImg(item) {
				this.selectedId = item.id;
				this.selectedUrl = item.imageUrl;
			},
			confirm() {
				if (!this.selectedId) {
					this.$message.warning("请先选择图片");
					return;
				}
				this.$emit("confirm", {
					shareImgId: this.selectedId,
					shareImgUrl: this.selectedUrl,
				});
			},
			updateIndicator() {
				const index = this.list.findIndex((i) => i.id === this.selectedCategoryId);
				if (index === -1) return;
				const buttonItem = this.$refs.buttonItems[index];
				if (!buttonItem) return;
				this.indicatorLeft = buttonItem.offsetLeft;
				this.indicatorWidth = buttonItem.offsetWidth;
			},
		},
		computed: {
			indicatorStyle() {
				return {
					width: this.indicatorWidth + "px",
					transform: `translateX(${this.indicatorLeft}px)`,
					transition: "all 0.3s ease",
				};
			},
		},
	};
</script>

<style scoped>
	.share-image-dialog {
		padding: 15px;
		background: #fff;
	}

	.heading {
		width: 100%;
		font-size: 19px;
		font-weight: 500;
		color: #323B5A;
		line-height: 1;
		text-align: center;
		margin-top: 10px;
	}

	.img-button {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-top: 15px;
		padding: 0 11px;
		position: relative;
		justify-content: space-between;
	}

	.button-item {
		cursor: pointer;
		color: #4C4A56;
		font-weight: 500;
		font-size: 16px;
	}

	.button-item.active {
		color: #3A60FF;
	}

	.indicator {
		position: absolute;
		bottom: -10px;
		height: 5px;
		background-color: #3a60ff;
		border-radius: 15px;
		left: 0;
		transition: all 0.2s ease;
	}

	.img-list {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		min-height: 120px;
	}

	.img-item {
		width: 120px;
		height: 120px;
		border: 1px solid #dcdde0;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
		position: relative;
	}

	.img-item img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img-item.active {
		border-color: #3a60ff;
		box-shadow: 0 0 4px #3a60ff;
	}
	
	.img-item.active::after {
		display: block;
		content: "";
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.5);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	
	.img-item.active .icon {
		width: 22px;
		height: 22px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
	}

	.empty {
		width: 100%;
		text-align: center;
		color: #999;
		line-height: 120px;
	}

	.operation {
		display: flex;
		justify-content: space-evenly;
		margin-top: 25px;
	}

	.operation .cancel,
	.operation .confirm {
		width: 130px;
		height: 46px;
		line-height: 46px;
		font-size: 15px;
		font-weight: 600;
		border-radius: 25px;
		text-align: center;
		cursor: pointer;
	}

	.operation .cancel {
		color: #3a60ff;
		background-color: #ffffff;
		border: 1px solid #3a60ff;
	}

	.operation .confirm {
		color: #fff;
		background-color: #3a60ff;
		border: 1px solid #3a60ff;
	}
</style>


// WEBPACK FOOTER //
// src/components/ShareImageDialog/index.vue